import { pending, rejected, fulfilled } from './async';
import { getAddress } from 'app/api/others';

/**
 * Get all responsibles action
 */
export function find(zip_code) {
    return dispatch => {
        dispatch(pending('SEARCH_ADDRESS'));
        getAddress(zip_code)
            .then(res => {
                    dispatch(fulfilled('SEARCH_ADDRESS', res));
                    dispatch({ type: 'SAVE_UPDATE_MODAL_NOTIFICATION_HIDE' });
            })
            .catch(err => {
                dispatch({ type: 'SAVE_UPDATE_MODAL_NOTIFICATION_SHOW', payload: err });
                dispatch(rejected('SEARCH_ADDRESS'));
            });
    };
}

/**
 * Reset search address state action
 */
export const reset = () => ({
    type: 'SEARCH_ADDRESS_RESET',
});
